import JargonPage from '@cinch/oxd-pages/jargon/src'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import htmlSerializer, { linkResolver } from '@somo/oxd-apps-www/src/utils/html-serializer'
import { graphql } from 'gatsby'
import { RichText } from 'prismic-reactjs'
import React from 'react'
import SEO, { Breadcrumb } from '../components/seo'

// IRIS have added these to EVERY document, so we need to strip them here.
// TODO: Remove this method once documents have been cleaned in prismic.
const stripCinch = (str: string) => str.replace(' | cinch', '')

interface JargonPage extends Cinch.SitePage {
  data: any
  pageContext: any
}

const Page: React.FC<JargonPage> = ({ data, location, pageContext }) => {
  const { prismic } = data
  const doc = prismic.allJargons.edges.slice(0, 1).pop()

  if (!doc) {
    return null
  }

  const term = doc.node.term || ''
  const fullTerm = doc.node.full_term || ''
  const question = doc.node.question || ''
  const summary = doc.node.summary || ''
  const definition = doc.node.definition || ''
  const image = doc.node.image
  const keywords = (doc.node.keywords && doc.node.keywords.map(({ keyword }: any) => keyword)) || []
  const relatedJargon = doc.node.related_jargon
    .map(({ jargon }: any) => jargon)
    .filter(Boolean)
    .map((item: any) => {
      const {
        question: title,
        summary: subtitle,
        _meta: { uid: id },
      } = item

      return {
        title,
        subtitle,
        id,
      }
    })

  const seoNode = doc.node.body && doc.node.body[0].primary
  const seoProps = {
    title: (seoNode && stripCinch(seoNode.title_tag)) || question,
    desc: (seoNode && seoNode.meta_description) || summary,
  }

  const breadcrumbs: Breadcrumb[] = []

  if (location) {
    const pageUrl = `${getEnv(Env.SiteUrl)}${location.pathname}`
    breadcrumbs.push(
      {
        item: `${getEnv(Env.SiteUrl)}/jargon`,
        name: 'Jargon Buster',
      },
      {
        item: pageUrl,
        name: seoProps.title,
      },
    )
  }

  return (
    <>
      <SEO {...seoProps} breadcrumbs={breadcrumbs} />
      <JargonPage
        id={pageContext.uid}
        term={term}
        fullTerm={fullTerm}
        question={question}
        keywords={keywords}
        relatedItems={relatedJargon}
        image={image}
        definition={RichText.render(definition, linkResolver, htmlSerializer)}
      />
    </>
  )
}

export const query = graphql`
  query JargonPageQuery($uid: String) {
    prismic {
      allJargons(uid: $uid) {
        edges {
          node {
            body {
              ... on PRISMIC_JargonBodySeo {
                primary {
                  title_tag
                  meta_description
                }
              }
            }
            term
            full_term
            summary
            question
            definition
            image
            keywords {
              keyword
            }
            _meta {
              uid
            }
            related_jargon {
              jargon {
                ... on PRISMIC_Jargon {
                  question
                  summary
                  _meta {
                    uid
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export default Page
